import { App } from '@capacitor/app';
import { focusManager } from '@tanstack/react-query';
import { useEffect } from 'react';
import { isCordova } from 'utils/platform';

export function useAppState() {
  useEffect(() => {
    if (!isCordova()) {
      return undefined;
    }

    const resumeListener = App.addListener('resume', () => {
      focusManager.setFocused(true);
    });

    const pauseListener = App.addListener('pause', () => {
      focusManager.setFocused(false);
    });

    return () => {
      resumeListener.then((handle) => handle.remove());
      pauseListener.then((handle) => handle.remove());
    };
  }, []);
}
